// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AppEvent } from '@interfaces/interfaces';
import { debounceTime, distinctUntilChanged, takeWhile } from 'rxjs';

@Component({
    selector: 'search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit, OnChanges {
    @Input() label = 'Search for a customer, deal #, vin, or stock number...';
    @Input() isFiltered = false;
    @Output() public outEvent: EventEmitter<AppEvent> = new EventEmitter();
    private isComponentAlive = true;
    public searchForm: FormGroup;

    ngOnInit(): void {
        this.buildForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.isFiltered.firstChange) {
            this.isFiltered = changes.isFiltered.currentValue;
        }
    }

    private buildForm(): void {
        this.searchForm = new FormGroup({
            query: new FormControl(''),
        });

        this.searchForm
            .get('query')
            .valueChanges.pipe(
                takeWhile(() => this.isComponentAlive),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((queryValue: string) => {
                this.outEvent.emit({
                    context: 'query',
                    data: queryValue,
                });
            });
    }

    public clear() {
        this.searchForm.get('query').setValue('');
    }

    public searchDeals(): void {
        this.outEvent.emit({
            context: 'search',
            data: this.searchForm.controls.query.value ?? {},
        });
    }
}
